import { render } from "./FileUploadView.vue?vue&type=template&id=dca57190&scoped=true"
import script from "./FileUploadView.vue?vue&type=script&lang=js"
export * from "./FileUploadView.vue?vue&type=script&lang=js"

import "./FileUploadView.vue?vue&type=style&index=0&id=dca57190&scoped=true&lang=css"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca57190"]])

export default __exports__